module.exports = __webpack_public_path__ + "img/session-add.ce37800c.png";